import useLocalStorage from './use-localstorage'

// prettier doesnt recognize this comma for generic types in ts files
// eslint-disable-next-line prettier/prettier
const useObjectStorage = <T,>(key: string, initialValue: T) => {
  const [storedValue, setStoredValue] = useLocalStorage(key, initialValue)

  const storedObject = typeof storedValue === 'string' ? JSON.parse(storedValue) : storedValue

  const setStoredObject = (value: T) => {
    setStoredValue(JSON.stringify(value))
  }

  return [storedObject, setStoredObject]
}

export default useObjectStorage
